import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track16EBlack = ({ state, workState, onLabelClick }) => (
	<g id="Track16EBlack" transform="translate(2294.000000, 444.000000)" className="track">
		<g id="line"
			 transform="translate(0.236007, 0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M211,241.419106 C191.926742,257.913859 163.726064,258.208794 144.311997,242.116557 L85.8473816,193.655487 L85.8473816,193.655487"/>

			<TrackArrow transform="translate(75.847576, 184.339826) rotate(-138.000000) translate(-75.847576, -184.339826) "
									points="79.8475764 192.339826 71.8475764 184.339826 79.8475764 176.339826"/>
			<path
				d="M77.5511539,185.796793 L46.1567681,157.515366 L25.9292652,133.478505 C11.4823578,116.310874 3.22880635,94.7834602 2.49581298,72.3579525 L0.130712972,-0.000912342457 L0.130712972,-0.000912342457"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track16EBlack')}
			coords="22.724288, 134.976562"
			text="16E"
			textCoordsX="7.28222656"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>
	</g>
);

Track16EBlack.propTypes = trackPropTypes;

export default Track16EBlack;
